export default "/images/octagon.svg?a6ea5fa517cbb4566808b7399744101f";